import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import { Row, Col, Button } from 'reactstrap';
import MenuItem from '@material-ui/core/MenuItem';
import Spinner from 'react-bootstrap/Spinner';
import AlertModal from '../../../../shared/components/Modal';

const FormConfigEmail = () => {

    //Componente
    const [warningModal, setWarningModal] = React.useState(false);
    const [successModal, setSuccessModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [errors, setErrors] = React.useState({});

    //Parametros de Configuracion
    const [host, setHost] = React.useState(null);
    const [port, setPort] = React.useState(null);
    const [secureProv, setSecureProv] = React.useState(null);
    const [user, setUser] = React.useState(null);
    const [password, setPassword] = React.useState(null);
    const [email, setEmail] = React.useState(null);

    React.useEffect(() => {
        getPublicDataConfig();
    }, []);

    const getPublicDataConfig = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'parametrizacion-correo/get-config', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Ha ocurrido un error en el servidor');
            }
        }).then(data => {
            setHost(data.config.configSMTP.host);
            setPort(data.config.configSMTP.port);
            setSecureProv(data.config.configSMTP.secure);
            setUser(data.config.configSMTP.auth.user);
            setPassword(data.config.configSMTP.auth.pass);
            setEmail(data.config.correo);
        }).catch((e) => {
            console.log(e);
        });
    }

    const emptyFields = () => {
        var errors = {};
        var error = false;

        if (host === "" || host === undefined || host === null) {
            errors.host = "El Host es Obligatorio";
            error = true;
        } else {
            errors.host = "";
        }

        if (port === "" || port === undefined || port === null) {
            errors.port = "El Puerto es Obligatorio";
            error = true;
        } else {
            errors.port = "";
        }

        if (secureProv === "" || secureProv === undefined || secureProv === null) {
            errors.secureProv = "La seguridad aportada en el Proveedor es Obligatorio";
            error = true;
        } else {
            errors.secureProv = "";
        }

        if (user === "" || user === undefined || user === null) {
            errors.user = "El Usuario es Obligatorio";
            error = true;
        } else {
            errors.user = "";
        }

        if (email === "" || email === undefined || email === null) {
            errors.email = "El correo electrónico es obligatorio";
            error = true;
        } else {
            errors.email = "";
        }

        if (password === "" || password === undefined || password === null) {
            errors.password = "La contraseña es obligatoria";
            error = true;
        } else {
            errors.password = "";
        }

        setErrors(errors);
        return error;
    }

    const saveConfig = async () => {
        setWarningModal(false);
        setIsLoading(true);
        let dataSend = {
            host: host,
            port: port,
            secure: secureProv,
            user: user,
            password: password,
            email: email,
        }

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'parametrizacion-correo/send-config', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Ha ocurrido un error en el servidor');
            }
        }).then(data => {
            setSuccessModal(true);
            setIsLoading(false);
        }).catch((e) => {
            setErrorModal(true);
            setIsLoading(false);
            console.log(e);
        });
    }

    return (
        <div>
            <div className="card__title">
                <h5 className="bold-text">Configuración de Correo Electronico</h5>
                <h5 className="subhead">Escriba Parametros para la configuración de Envio de Correos Electronicos entregados por su Proveedor.</h5>
            </div>
            <Row>
                <Col md={3}>
                    <TextField
                        id=""
                        label="Host"
                        value={host}
                        placeholder='Host'
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' }, shrink: true
                        }}
                        onChange={(e) => {
                            setHost(e.target.value);
                        }}
                        style={{ marginLeft: 20, width: '100%' }}
                        error={errors.hasOwnProperty("host") ? errors.host !== "" : false}
                        helperText={errors.host}
                    />
                </Col>
                <Col md={3}>
                    <TextField
                        id=""
                        label="Puerto"
                        type="number"
                        value={port}
                        placeholder='Puerto'
                        onChange={(e) => {
                            setPort(e.target.value);
                        }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' }, shrink: true
                        }}
                        style={{ marginLeft: 20, width: '100%' }}
                        error={errors.hasOwnProperty("port") ? errors.port !== "" : false}
                        helperText={errors.port}
                    />
                </Col>
                <Col md={3}>
                    <TextField
                        id=""
                        label="Secure Prov"
                        placeholder='Secure Prov'
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' }, shrink: true
                        }}
                        value={secureProv}
                        onChange={(e) => {
                            setSecureProv(e.target.value);
                        }}
                        select
                        style={{ marginLeft: 20, width: '100%' }}
                        error={errors.hasOwnProperty("secureProv") ? errors.secureProv !== "" : false}
                        helperText={errors.secureProv}
                    >
                        <MenuItem key={1} value={true}>Si</MenuItem>
                        <MenuItem key={2} value={false}>No</MenuItem>
                    </TextField>
                </Col>
                <Col md={3}>
                    <TextField
                        id=""
                        label="Usuario"
                        placeholder='Usuario'
                        value={user}
                        onChange={(e) => {
                            setUser(e.target.value);
                        }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' }, shrink: true
                        }}
                        style={{ marginLeft: 20, width: '100%' }}
                        error={errors.hasOwnProperty("user") ? errors.user !== "" : false}
                        helperText={errors.user}
                    />
                </Col>
                <Col md={3}>
                    <TextField
                        id=""
                        label="Contraseña"
                        placeholder='Contraseña'
                        type="password"
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value);
                        }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' }, shrink: true
                        }}
                        style={{ marginLeft: 20, width: '100%' }}
                        error={errors.hasOwnProperty("password") ? errors.password !== "" : false}
                        helperText={errors.password}
                    />
                </Col>
                <Col md={3}>
                    <TextField
                        id=""
                        label="Correo Electronico"
                        placeholder='Correo Electronico'
                        type="email"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                        }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' }, shrink: true
                        }}
                        style={{ marginLeft: 20, width: '100%' }}
                        error={errors.hasOwnProperty("email") ? errors.email !== "" : false}
                        helperText={errors.email}
                    />
                </Col>
            </Row>

            {
                !isLoading ? <Button
                    style={{ marginTop: 20 }}
                    color="primary"
                    onClick={() => {
                        if (!emptyFields()) {
                            setWarningModal(true);
                        }
                    }}
                >
                    Guardar Configuracion
                </Button> : <div className="text-center">
                    <Spinner animation="border" variant="success" />
                </div>
            }

            <AlertModal
                color="warning"
                title="Esta seguro que desea enviar estos Parametros de Configuración de Correo?"
                modal={warningModal}
                onOk={() => saveConfig()}
                toggle={() => setWarningModal(false)}
            />

            <AlertModal
                color="success"
                title="Configuración de Correo Electronico Parametrizada Correctamente"
                modal={successModal}
                onOk={() => setSuccessModal(false)}
                toggle={() => setSuccessModal(false)}
            />

            <AlertModal
                color="danger"
                title="Ha ocurrido un error configurando la Parametrización de Correo Electronico"
                modal={errorModal}
                onOk={() => setErrorModal(false)}
                toggle={() => setErrorModal(false)}
            />
        </div>


    )
};

export default FormConfigEmail;